import { defineComponent, onMounted } from 'vue';
import DateCode from '@/presentation/components/campaign-settings/date-end/date-end.code';

export default defineComponent({
	setup: () => {
		const code = new DateCode();

		onMounted(code.prefillDatePicker.bind(code));

		return {
			datePicker: code.datePicker,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid,
			shouldFieldBeDisabled: code.shouldFieldBeDisabled,
			setDate: code.setDate.bind(code)
		};
	}
});
